import { render, staticRenderFns } from "./IconDocumentSearchSolid.vue?vue&type=template&id=40413dc0"
import script from "./IconDocumentSearchSolid.vue?vue&type=script&lang=js"
export * from "./IconDocumentSearchSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports